import { HEARD_ABOUT_US_SMALL_MAPPER, SOURCE_TO_COLOR_MAPPER } from "../../constants/common";

export const stripEmojis = (text) => {
  if (!text) return text;
  return text
    .replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu, "")
    .replace(/\s{2,}/g, " ")
    .trim();
};

export const formatMessage = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => {
    line = line.trim();

    // 🔹 Handle bullet points
    if (line.startsWith("* ")) {
      return (
        <li key={index} className="ml-4 list-disc text-gray-700 text-sm">
          {line.substring(2)}
        </li>
      );
    }

    // 🔹 Handle <a href="..."> links
    // This regex captures: <a href="URL">label</a>
    const linkRegex = /<a\s+href=['"]([^'"]+)['"][^>]*>(.*?)<\/a>/gi;

    // Split the line into text and links
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(line)) !== null) {
      const [fullMatch, url, label] = match;

      // Push text before the link
      if (match.index > lastIndex) {
        parts.push(line.substring(lastIndex, match.index));
      }

      // Push the link element
      parts.push(
        <a
          key={`${index}-${match.index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-800"
        >
          {label}
        </a>
      );

      lastIndex = match.index + fullMatch.length;
    }

    // Push any remaining text after the last link
    if (lastIndex < line.length) {
      parts.push(line.substring(lastIndex));
    }

    // 🔹 Handle bold text (**bold**)
    const boldProcessed = parts.map((part, i) => {
      if (typeof part !== "string") return part; // skip links
      const boldSplit = part.split(/(\*\*.*?\*\*)/g);
      return boldSplit.map((b, j) => {
        if (b.startsWith("**") && b.endsWith("**")) {
          return (
            <strong key={`${i}-${j}`} className="font-semibold">
              {b.slice(2, -2)}
            </strong>
          );
        }
        return b;
      });
    });

    return (
      <span key={index} className="text-gray-700 text-sm">
        {boldProcessed.flat()}
      </span>
    );
  });
};

export const getNewPageLink = (link) => {
  if (link.startsWith("http")) {
    return link;
  }
  return `https://${link}`
}

export const getNewSourcedCandidateObject = (counts = {}) => {
  const total = Object.values(counts).reduce((sum, count) => sum + count, 0);

  const result = Object.entries(counts).map(([source, count]) => ({
    source: HEARD_ABOUT_US_SMALL_MAPPER[source] || source,
    percentage: Math.floor((count / total) * 100),
    color: SOURCE_TO_COLOR_MAPPER[source]
  }));

  return result
}